import React from 'react';
import {Grid, Typography} from '@deere/fuel-react';
import {QBIC, QUARTILE} from "../shared/Constants";

export const RatingObjectiveQPPMDetails = ({title, isRequired, qbicName="", quartile="", path, index}) => {
    return (
        <Grid container alignItems="center" spacing={2} key={index}>
            <Grid item xs={12}>
                <Typography
                    color="primary" size="md"
                    style={{
                        paddingLeft: '10px',
                        paddingRight: '2rem'
                    }}>
                    {title}
                    {isRequired ? (
                        <span style={{
                            marginLeft: ".25rem",
                            display: "inline"
                        }}
                            aria-label="required field"
                            className="uxf-is-required"
                        > * </span>
                    ) : ""}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography
                    fontWeight="semibold" size="md" display="inline"
                    style={{
                        paddingLeft: '10px',
                        paddingRight: '.5rem'
                    }}>
                    {QBIC}:
                </Typography>
                <Typography
                    color="tertiary" size="md" display="inline" style={{paddingRight: '2rem'}}>
                    {qbicName ? qbicName : "N/A"}
                </Typography>
                <Typography
                    fontWeight="semibold" size="md" display="inline"
                    style={{
                        paddingLeft: '10px',
                        paddingRight: '.5rem'
                    }}>
                    {QUARTILE}:
                </Typography>
                <Typography
                    color="tertiary" size="md" display="inline" style={{paddingRight: '2rem'}}>
                    {quartile ? quartile : "N/A"}
                </Typography>
                {/*<Link href={path} target="_blank"*/}
                {/*      rel="noopener noreferrer">{VIEW_PERFORMANCE_GRAPH}*/}
                {/*</Link>*/}
            </Grid>
        </Grid>
    )
}
